import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  height: 100%;
`;

export const PageHeader = styled.div`
  background: var(--surface);
  padding: 105px 0 30px;
  text-align: center;
  border-bottom: 2px solid var(--accent-light);

  h1 {
    font-size: 48px;
    font-weight: 700;
    margin-bottom: 20px;
    text-transform: uppercase;
    letter-spacing: 2px;
    background: var(--gradient-primary);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;

    @media (max-width: 768px) {
      font-size: 36px;
    }
  }

  p {
    font-size: 16px;
    color: var(--text-muted);
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.8;
  }
`;

export const ContentSection = styled.div`
  padding: 60px 40px;
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 20px;
  }
`;

export const ContentContainer = styled.div`
  background: var(--surface);
  padding: 40px;
  border-radius: 25px;
  border: 2px solid var(--accent-light);
  box-shadow: var(--shadow-soft);

  @media (max-width: 768px) {
    padding: 30px 20px;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
  margin-top: 40px;
  text-transform: uppercase;
  color: var(--text-primary);
  position: relative;
  padding-bottom: 15px;

  &:first-child {
    margin-top: 0;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 50px;
    height: 3px;
    background: var(--gradient-primary);
  }
`;

export const SubsectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  margin-top: 30px;
  color: var(--text-primary);

  &:first-child {
    margin-top: 0;
  }
`;

export const TextContent = styled.div`
  font-size: 16px;
  line-height: 1.8;
  color: var(--text-secondary);
  margin-bottom: 20px;

  p {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    padding-left: 20px;
    margin-bottom: 16px;

    li {
      margin-bottom: 8px;
      line-height: 1.6;
    }
  }

  strong {
    color: var(--text-primary);
    font-weight: 600;
  }

  em {
    color: var(--accent);
    font-style: italic;
  }
`;

export const ImportantNotice = styled.div`
  background: rgba(232, 165, 165, 0.1);
  border: 2px solid var(--accent-light);
  border-radius: 15px;
  padding: 20px;
  margin: 30px 0;

  .notice-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--accent);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;

    svg {
      margin-bottom: 1px;
    }
  }

  .notice-content {
    font-size: 14px;
    line-height: 1.6;
    color: var(--text-secondary);
  }
`;

export const ContactInfo = styled.div`
  background: var(--background);
  border-radius: 15px;
  padding: 30px;
  margin-top: 40px;
  border: 2px solid var(--accent-light);

  h4 {
    font-size: 18px;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 15px;
  }

  .contact-details {
    display: grid;
    gap: 10px;

    .contact-item {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      color: var(--text-secondary);

      .icon {
        color: var(--accent);
        font-size: 16px;
      }

      a {
        color: var(--accent);
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`;

export const LastUpdated = styled.div`
  text-align: center;
  padding: 20px;
  font-size: 14px;
  color: var(--text-muted);
  border-top: 1px solid var(--accent-light);
  margin-top: 40px;

  strong {
    color: var(--text-primary);
  }
`;
